import React, { useEffect, useState } from 'react';


export default function TokenDetails(props) {
    const [ token, setToken ] = useState(null);
    const [ metadata, setMetadata ] = useState(null);

    const sanityzePlotMetadata = (metadata) => {
        let fields = metadata.substring(1, metadata.length - 1).split(',');
        fields[4] = fields[4] + ',' + fields[5] + ',' + fields[6];
        fields = fields.slice(0, 5).concat(fields.slice(-2));
        let meta = [];
        fields.map((field) => meta[field.split(': ')[0]] = field.split(': ')[1]);
        return(meta);
    }

    const sanityzeCo2Metadata = (metadata) => {
        let fields = metadata.substring(1, metadata.length - 1).split(',');
        let plots = '';
        fields.slice(2, fields.length - 3).map((field) => {
            return plots += field + ',';
        })
        fields[2] = plots.substring(0, plots.length - 1);
        fields = fields.slice(0, 3).concat(fields.slice(-3));
        let meta = [];
        fields.map((field) => meta[field.split(': ')[0]] = field.split(': ')[1]);
        return(meta);
    }

    useEffect(() => {
        if (token === null) {
            fetch('https://nftree.herokuapp.com/api/nft/get?nftid=' + props.match.params.id + '&protocol=' + props.match.params.protocol, {})
            .then((res) => res.json()
                .then((data) => {
                    setToken(data.message);
                    if (data.message.nftProtocolId === 'plot')
                        setMetadata(sanityzePlotMetadata(data.message.metadata));
                    else
                        setMetadata(sanityzeCo2Metadata(data.message.metadata));
                }))
            .catch((err) => console.log(err));
        }
    });

    if (token === null)
        return(<>Loading</>)
    
    return(
	<>
        <header className="bg-white shadow">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold leading-tight text-gray-900">
                NFT Details
                </h1>
            </div>
        </header>
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="border-t border-gray-200">
                <dl>
                    <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        NFT Id
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        { token.nftId }
                        </dd>
                    </div>
                    <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        NFT Proto
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        { token.nftProtocolId }
                        </dd>
                    </div>
                    <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        NFT Owner Address
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        { token.nftOwnerKeyId }
                        </dd>
                    </div>
                    <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        NFT Tx Id
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        { token.registrationTxHash }
                        </dd>
                    </div>
                    <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        NFT Metadata
                        </dt>
                        <dd className="mt-1 w-full text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                            { metadata ? Object.keys(metadata).map((key, value) => {
                                return (
                                    <div key={ value } className="flex">
                                        <div className="justify-center items-center w-1/3 text-sm font-medium text-gray-500 mx-2">
                                            { key }:
                                        </div>
                                        <div className="justify-center items-center mt-1 w-1/2 text-sm text-gray-900 sm:mt-0 sm:col-span-2 mx-2 my-2">
                                            { metadata[key] }
                                        </div>
                                    </div>
                                );
                            }) : null}
                        </dd>
                    </div>
                    <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                        Created
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        { (new Date(token.timestamp * 1000)).toLocaleString() }
                        </dd>
                    </div>                    
                </dl>
            </div>
        </div>
	</>
    );
}

